import React, { Component } from "react";
import createToolbarPlugin, {
  Separator,
} from "@draft-js-plugins/static-toolbar";
import {
  ItalicButton,
  BoldButton,
  UnderlineButton,
  CodeButton,
  HeadlineOneButton,
  HeadlineTwoButton,
  HeadlineThreeButton,
  UnorderedListButton,
  OrderedListButton,
  BlockquoteButton,
  CodeBlockButton,
} from "@draft-js-plugins/buttons";
import "@draft-js-plugins/static-toolbar/lib/plugin.css";

class HeadlinesPicker extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    this.hiddenFileInput.current.click();

    setTimeout(() => {
      window.addEventListener("click", this.onWindowClick);
    });
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.onWindowClick);
  }

  onWindowClick = () => this.props.onOverrideContent(undefined);

  render() {
    const buttons = [HeadlineOneButton, HeadlineTwoButton, HeadlineThreeButton];
    return (
      <div>
        {buttons.map((Button, i) => (
          <Button key={i} {...this.props} />
        ))}
      </div>
    );
  }
}

class HeadlinesButton extends Component {
  onClick = () => this.props.onOverrideContent(HeadlinesPicker);

  render() {
    return (
      <div className="headlineButtonWrapper">
        <button onClick={this.onClick} className="headlineButton">
          H
        </button>
      </div>
    );
  }
}

export const toolbarPlugin = createToolbarPlugin();
const { Toolbar } = toolbarPlugin;
export const StaticToolBarPlugins = [toolbarPlugin];

export default class StaticToolbar extends Component {
  constructor(props) {
    super(props);
    this.hiddenFileInput = React.createRef(null);
    this.state = {
      attachments: [],
    };
  }

  fileUpload = () => {
    this.props.getImages();
    // this.hiddenFileInput?.current?.click();
  };
  fileUploadHandler = (evt) => {
    const attachments = [...this.state.attachments];
    attachments.push(...evt.target.files);
    this.setState({ ...this.state, attachments: attachments }, () => {
      this.props.getImages(this.state.attachments);
      this.setState({ ...this.state, attachments: [] });
    });
  };
  render() {
    return (
      <div className="staticToolbar">
        <Toolbar>
          {(externalProps) => (
            <div>
              <BoldButton {...externalProps} />
              <ItalicButton {...externalProps} />
              <UnderlineButton {...externalProps} />
              <Separator {...externalProps} />
              <div style={{ display: "inline-block" }}>
                <button
                  onClick={this.props.toggleLink}
                  className="fileButton"
                  title="Add Link"
                  type="button"
                >
                  <i className="fa fa-link"></i>
                </button>
              </div>
              {this.props.fileFalse && (
                <div style={{ display: "inline-block" }}>
                  <button
                    className="fileButton"
                    type="button"
                    onClick={this.fileUpload}
                  >
                    {" "}
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.88835 14.6527C6.97288 14.6749 6.08595 14.3332 5.42204 13.7025C4.75813 13.0718 4.37141 12.2035 4.34668 11.2881V5.285C4.3637 4.62324 4.6422 3.99518 5.12122 3.53829C5.60024 3.08139 6.24076 2.83288 6.90258 2.84715C7.56541 2.8313 8.20745 3.0791 8.68776 3.53616C9.16806 3.99323 9.44738 4.6222 9.46439 5.285V11.294C9.43984 11.6946 9.26342 12.0707 8.9711 12.3456C8.67879 12.6206 8.2926 12.7737 7.8913 12.7737C7.48999 12.7737 7.10381 12.6206 6.81149 12.3456C6.51918 12.0707 6.34276 11.6946 6.31821 11.294V5.75132C6.31821 5.59477 6.3804 5.44463 6.4911 5.33393C6.60179 5.22323 6.75193 5.16104 6.90849 5.16104C7.06504 5.16104 7.21518 5.22323 7.32587 5.33393C7.43657 5.44463 7.49876 5.59477 7.49876 5.75132V11.294C7.51053 11.3898 7.55695 11.478 7.62925 11.542C7.70156 11.606 7.79476 11.6413 7.8913 11.6413C7.98784 11.6413 8.08104 11.606 8.15334 11.542C8.22565 11.478 8.27206 11.3898 8.28383 11.294V5.285C8.26548 4.9358 8.11015 4.60792 7.85156 4.37253C7.59296 4.13714 7.25197 4.01324 6.90258 4.02771C6.5542 4.01483 6.21472 4.13945 5.95741 4.37467C5.7001 4.6099 5.54559 4.93686 5.52724 5.285V11.2881C5.55181 11.8905 5.81409 12.4585 6.25664 12.8679C6.69918 13.2772 7.28592 13.4945 7.88835 13.4722C8.49077 13.4945 9.07751 13.2772 9.52006 12.8679C9.9626 12.4585 10.2249 11.8905 10.2495 11.2881V5.285C10.2495 5.12845 10.3116 4.97831 10.4223 4.86761C10.533 4.75691 10.6832 4.69472 10.8397 4.69472C10.9963 4.69472 11.1464 4.75691 11.2571 4.86761C11.3678 4.97831 11.43 5.12845 11.43 5.285V11.2881C11.4053 12.2035 11.0186 13.0718 10.3547 13.7025C9.69074 14.3332 8.80382 14.6749 7.88835 14.6527Z"
                        fill="#717171"
                        fill-opacity="0.8"
                      ></path>
                    </svg>
                  </button>
                </div>
              )}
              <UnorderedListButton {...externalProps} />
              <OrderedListButton {...externalProps} />
            </div>
          )}
        </Toolbar>
        <input
          type="file"
          onChange={this.fileUploadHandler}
          style={{ display: "none" }}
          ref={this.hiddenFileInput}
          multiple={true}
        />
      </div>
    );
  }
}
